import React, { Component } from 'react'
import './Portfolio.css'

import Bio from './Bio'
import ProjectPreview from './ProjectPreview'
import Footer from './Footer'
import Res from '../values/Resources'

export default class Portfolio extends Component {



	render() {
		return (
			<div className='portfolio'>
				<Bio/>
				{Res.projects.map((project, i) => (
					<ProjectPreview key={project.id} project={project} index={i}/>
				))}
				<Footer/>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Portfolio.js